import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { initTelemetry } from './util/telemetry';

initTelemetry();

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

function render() {
	root.render(
		<React.StrictMode>
			<App />
		</React.StrictMode>
	);
}

render();
